var map = {
	"./ada.svg": "d394",
	"./algo.svg": "88bd",
	"./bch.svg": "88db",
	"./bnb.svg": "475f",
	"./btc.svg": "34bb",
	"./cake.svg": "1a40",
	"./darik.svg": "752c",
	"./default.svg": "edcd",
	"./doge.svg": "c73b",
	"./dot.svg": "736b",
	"./drc.svg": "fce2",
	"./etc.svg": "1d22",
	"./eth.svg": "1130",
	"./gtc.svg": "4f02",
	"./hot.svg": "f62d",
	"./iotx.svg": "6ee0",
	"./irt.svg": "8828",
	"./itc.svg": "23cbc",
	"./ltc.svg": "e038",
	"./omg.svg": "30bd",
	"./ont.svg": "d9c5",
	"./shib.svg": "c882",
	"./sol.svg": "8494",
	"./trx.svg": "d227",
	"./uni.svg": "3d8f",
	"./usdc.svg": "623c",
	"./usdt.svg": "eebf",
	"./xlm.svg": "2a0a",
	"./xmr.svg": "25e3",
	"./xrp.svg": "91b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c56";